import { render } from "./SlimDetails.vue?vue&type=template&id=76aecb06"
import script from "./SlimDetails.vue?vue&type=script&lang=js"
export * from "./SlimDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__